import type { OnboardingStepMap } from "@/components/onboarding/components/welcome-wizard";
import { ReferrerStepsMap } from "@/components/onboarding/components/welcome-wizard/steps/icp/referrer-step";
import { NativeAppDownloadStepMap } from "@/components/onboarding/components/welcome-wizard/steps/native-app-download-steps";
import { SystemPermissionsMeetingsStepsMap } from "@/components/onboarding/components/welcome-wizard/steps/system-permissions-meetings";
import { SystemPermissionsVoiceStepsMap } from "@/components/onboarding/components/welcome-wizard/steps/system-permission-voice";
import { CalendarSetupStepsMap } from "@/components/onboarding/components/welcome-wizard/steps/calendar-setup";
import { ProactiveTrialStepMap } from "@/components/onboarding/components/welcome-wizard/steps/proactive-trial";
import { MemAgentStepMap } from "@/components/onboarding/components/welcome-wizard/steps/mem-agent";
import { IntentOnboardingStepMap } from "@/components/onboarding/components/welcome-wizard/steps/intent-onboarding-steps";

/**
 * Top-level step map keyed by OnboardingSubstepId.
 *
 * Each key must match a substep id declared in onboarding-step-definitions.ts.
 * TypeScript can't verify completeness through spreads of Record<string, ...>,
 * so we assert the combined result. Adding a new OnboardingSubstepId without a
 * matching entry here will surface at runtime via the null-guard in welcome-overlay.
 */
export const Steps = {
  ...IntentOnboardingStepMap,
  ...NativeAppDownloadStepMap,
  ...ReferrerStepsMap,
  ...CalendarSetupStepsMap,
  ...SystemPermissionsMeetingsStepsMap,
  ...SystemPermissionsVoiceStepsMap,
  ...ProactiveTrialStepMap,
  ...MemAgentStepMap,
} as OnboardingStepMap;
